import Reports from '@/screens/reports/Main'

import auth from './middleware/auth'

const routes = [
  {
    path: '/reportes',
    component: Reports,
    name: 'Reports',
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/reportes/clientes/ventas-brutas',
    name: 'sales-before-tax',
    component: () => import('../screens/reports/clients/SalesBeforeTax'),
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/reportes/clientes/ventas-netas',
    name: 'after-tax-sales',
    component: () => import('../screens/reports/clients/AfterTaxSales'),
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/reportes/compras/:id',
    name: 'purchases',
    component: () => import('../screens/reports/purchases/purchases/Index'),
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/reportes/inventario/:id',
    name: 'inventory',
    component: () => import('../screens/reports/purchases/inventory/Index'),
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  },
  {
    path: '/reportes/nomina',
    name: 'paysheet',
    component: () => import('../screens/reports/hr/PaySheet'),
    meta: {
      requireAuth: true,
      permissions: ['manager'],
      middleware: { auth }
    }
  }
]

export default routes
